const Subtitle = ({ title }) => {
  return <span className="subtitle_component">{title}</span>
}

export default Subtitle
